export default __webpack_public_path__ + "static/media/DecrementImg.52cbc4e9.jpg";